function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_blue_svg__a",
  x1: "0%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#27AAE6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#7651FF"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "url(#logo_blue_svg__a)",
  fillRule: "evenodd",
  transform: "translate(-83 -40)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M83.257 57c0 9.192 7.432 16.644 16.6 16.644 6.145 0 11.505-3.349 14.376-8.323l-10.27-5.945a4.735 4.735 0 01-4.105 2.38A4.75 4.75 0 0195.115 57a4.75 4.75 0 014.743-4.755V40.356c-9.169 0-16.601 7.452-16.601 16.644"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.083 52.804l5.568-10.5a16.476 16.476 0 00-7.793-1.948v11.889a4.7 4.7 0 012.225.559",
  opacity: 0.6
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.962 54.624l10.27-5.945a16.714 16.714 0 00-2.042-2.812l-8.811 7.955c.22.246.417.514.583.802",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.378 53.822l8.812-7.955a16.677 16.677 0 00-4.539-3.562l-5.568 10.499c.49.262.927.607 1.295 1.018",
  opacity: 0.4
}));

function SvgLogoblue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34"
  }, props), _ref, _ref2);
}

export default SvgLogoblue;